/**
 * Environment detection for observability and runtime behavior.
 * Hostname patterns mirror raptor-fe; local dev uses Vite `import.meta.env.DEV`.
 */
export type Environment = 'localhost' | 'development' | 'test' | 'qa' | 'uat' | 'production';

enum EnvUrlPattern {
  LOCAL = 'local',
  DEVELOPMENT = 'dev',
  QA = 'qa',
  UAT = 'uat',
  PRODUCTION = 'app'
}

export function getEnv(): Environment {
  if (import.meta.env.MODE === 'test') {
    return 'test';
  }

  if (typeof window === 'undefined') {
    return 'development';
  }

  const host = window.location.host.toLowerCase();

  if (host.includes(EnvUrlPattern.QA)) {
    return 'qa';
  }
  if (host.includes(EnvUrlPattern.UAT)) {
    return 'uat';
  }
  if (host.includes(EnvUrlPattern.PRODUCTION)) {
    return 'production';
  }
  if (host.includes(EnvUrlPattern.DEVELOPMENT) || host.includes(EnvUrlPattern.LOCAL)) {
    return host.includes(EnvUrlPattern.LOCAL) ? 'localhost' : 'development';
  }

  return 'development';
}

export function isDevelop(): boolean {
  return getEnv() === 'development';
}

export function isProduction(): boolean {
  return getEnv() === 'production';
}

export function isQA(): boolean {
  return getEnv() === 'qa';
}

export function isEnv(env: Environment): boolean {
  return getEnv() === env;
}

export const isRunningLocally = (): boolean => {
  if (import.meta.env.DEV) {
    return true;
  }
  return getEnv() === 'localhost';
};
